<template>
  <div class="input-group">
    <FormLabel
      :prepend="prepend"
      :required="required">
      <money
        v-model="numberValue"
        v-bind="money"
        :class="{'text-left': align == 'left', 'text-right': align == 'right', 'text-center': align == 'center'}"
        :placeholder="placeholder"
        :disabled="disabled"
        class="form-control" />
    </FormLabel>
  </div>
</template>

<script>
import { Money } from 'v-money';
import FormLabel from '@/components/Forms/FormLabel';

export default {
  name: 'FormInputNumber',
  components: { FormLabel, Money },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: 0.00,
    },
    prepend: {
      type: String,
      default: null,
    },
    align: {
      type: String,
      default: 'left',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    precision: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      numberValue: this.value,
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: this.precision,
        masked: false,
      },
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal || newVal === 0.0) this.numberValue = newVal;
      },
      immediate: true,
    },
    numberValue: {
      handler(newVal) {
        this.$emit('input', newVal);
      },
    },
    precision: {
      handler(newVal) {
        if (newVal) {
          this.money.precision = newVal;
          this.numberValue = parseFloat(this.numberValue).toFixed(newVal);
        }
      },
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.input-group {
  align-items: center;
}
.form-control {
  display: flex;
}
i {
  font-size: 10px;
}
</style>
